<ng-container *appTranslate="let t">
  <app-simple-menubar [items]="items" [selectedItem]="selectedItem" (selectedItemChange)="setSelectedItem($event)">
    <ng-template #selectedItemTemplate let-item>
      <div class="flex justify-content-between align-items-center w-full">
        <div [ngClass]="{ 'selected-item-error': !isNil(item.badge) }">
          {{ item.label }}
        </div>
        <small *ngIf="totalErrors > 0" class="p-error white-space-nowrap">
          {{ totalErrors }} {{ t("common.validationIssues") }}
        </small>
      </div>
    </ng-template>
    <ng-template #itemTemplate let-item>
      <div
        class="menu-item flex gap-2 align-items-center"
        [ngClass]="{
          'menuitem-active': item.id === (storageKey | observe | async),
          'menuitem-error': !isNil(item.badge),
        }"
      >
        {{ item.label }}
        <p-badge *ngIf="item.badge" severity="danger" [value]="item.badge"></p-badge>
      </div>
    </ng-template>
  </app-simple-menubar>

  <div *ngIf="selectedItem?.data as tab" class="overflow-y-auto">
    <p-panel>
      <formly-field [field]="tab"></formly-field>
    </p-panel>
  </div>
</ng-container>
